import React from "react"

const EmptyWarning = () => {
  return (
    <div
      className="bg-red-100 border-l-4 border-red-500 text-orange-700 p-4"
      role="alert"
    >
      <p className="font-bold text-2xl font-opensanscond">Пустая категория</p>
    </div>
  )
}

export default EmptyWarning
